import gql from "graphql-tag";
import actionFormContainer from "../../clientDispatches/forms/actionFormContainer";
import {cancelCancelPurchaseOrder, successCancelPurchaseOrder} from "../../../actions/PurchaseOrderApiActions";

export default actionFormContainer({
  mutation: gql`
    mutation cancelPurchaseOrder($data: CancelPurchaseOrderInput!) {
      cancelPurchaseOrder(input: $data) {
        errors { key message }
      }
    }
  `,
  resultField: "cancelPurchaseOrder",
  buildData: (props, values) => ({purchaseOrderId: props.purchaseOrderId, reason: values.get("reason")}),
  formProps: () => ({
    withReason: true,
    submitLabel: "Cancel Order",
    message: "Cancel this purchase order? It stops counting as incoming stock.",
  }),
  success: successCancelPurchaseOrder,
  cancel: cancelCancelPurchaseOrder,
});
